import React from "react";

const styles = (color: string) => ({
  borderRadius: "7px",
  width: "14px",
  height: "14px",
  color: "white",
  fontSize: "10px",
  textAlign: "center" as "center",
  lineHeight: "14px",
  display: "inline-block",
  backgroundColor: color,
  marginRight: "5px"
});

export default (props: { text: string; color: string }) => (
  <span style={styles(props.color)}>{props.text}</span>
);
